import { useMemo, useRef } from 'react'

import { getDimensionDataAsArray, getDimensionDataSignature } from './functions'

// Flattens the Immutable dimensionData into the plain grouped array react-select
// consumes, memoized so the linear flatten transform only re-runs when the
// content actually changes. Parents frequently hand down a NEW reference with
// identical content (selectors / inline .map()), so a plain [dimensionData]
// dependency would re-flatten on every render. We gate on a cheap content
// signature instead, and keep a per-dimension cache so a backend search merge
// only re-flattens the one dimension whose values changed.
export default function useFlattenedDimensionData(dimensionData) {
  const cache = useRef({ signature: null, result: null })
  const perDimensionCache = useRef(new Map())

  return useMemo(() => {
    const signature = getDimensionDataSignature(dimensionData)
    if (
      cache.current.result !== null &&
      cache.current.signature === signature
    ) {
      return cache.current.result
    }
    const result = getDimensionDataAsArray(
      dimensionData,
      perDimensionCache.current
    )
    cache.current = { signature, result }
    return result
  }, [dimensionData])
}
